import Vue from 'vue'
import PaymentForm from 'js/components/payment-forms/copy_and_pay'

export default Vue.mixin({
  components: {PaymentForm},
  data() {
    return {
      paymentAPI: 'copyAndPay'
    }
  },

  computed: {
    paymentPlatforms() {
      const platformConfig = this.currentAppConfig.payment_platform_config
      const mbway = {
        id: 'mbway',
        label: Vue.i18n.t('recharge.rechargeData.paymentPlatforms.mbway'),
        dataBrands: 'MBWAY'
      }
      const redsys = {
        id: 'redsys',
        label: Vue.i18n.t('recharge.rechargeData.paymentPlatforms.redsys'),
        dataBrands: 'REDSYS'
      }
      const copyAndPay = {
        id: 'copy_and_pay',
        label: Vue.i18n.t('recharge.rechargeData.paymentPlatforms.copyAndPay'),
        dataBrands: 'VISA MASTER'
      }
      const payStore = {
        id: 'paystore',
        label: Vue.i18n.t('recharge.rechargeData.paymentPlatforms.paystore'),
        dataBrands: 'PAYSTORE'
      }

      const platforms = []

      if (platformConfig.active_creditcard_redsys === true) {
        platforms.push(redsys)
      }

      if (platformConfig.active_mbway_sibs === true) {
        platforms.push(mbway)
      }

      if (platformConfig.active_creditcard_sibs === true) {
        platforms.push(copyAndPay)
      }

      if (platformConfig.active_paystore_redsys === true) {
        platforms.push(payStore)
      }

      return [...platforms]
    }
  },

  methods: {
    /*
     * Realizar el pago
     */
    goPaymentPlatform(dataBrands) {
      const baseUrl = this.rechargeData.payment_platform_base_url
      if (dataBrands === 'REDSYS') {
        this.paymentAPI = 'redsys'
      } else if (dataBrands === 'PAYSTORE') {
        this.paymentAPI = 'paystore'
      } else {
        this.scriptAttrs = {
          src: `${baseUrl}/v1/paymentWidgets.js?checkoutId=${this.rechargeData.token}`
        }
      }
      this.formAttrs = {
        action: this.rechargeData.pay_url,
        class: 'paymentWidgets',
        dataBrands
      }
      this.formDataReady = true
    }
  }
})
